import React from 'react';

type State = {
  watchListRow: string | null;
  return?: string;
};

type SelectedContainerContextType = [State, React.Dispatch<React.SetStateAction<State>>];

export const SelectedContainerContext = React.createContext<SelectedContainerContextType>([
  { watchListRow: null },
  () => {},
]);

interface Props {
  children?: React.ReactNode;
}

export const SelectedContainerContextProvider: React.FC<Props> = (props) => {
  const [selectedContainer, setSelectedContainer] = React.useState({
    watchListRow: null,
  });

  const contextValue: SelectedContainerContextType = React.useMemo(
    () => [selectedContainer, setSelectedContainer] as SelectedContainerContextType,
    [selectedContainer, setSelectedContainer]
  );

  return (
    <SelectedContainerContext.Provider value={contextValue}>
      {props.children}
    </SelectedContainerContext.Provider>
  );
};
